
export default {
  methods: {
    prefixServerImgPath(item) {
      return `/api/upload/image/${item.examinationID}/${item.file}`
    },
  }
}
